export default __webpack_public_path__ + "static/media/Accessories.c3915596.png";